import InputValidationStateBo from '../../../../../../form/input/InputValidationStateBo';
import InputValidator from '../../../../../../form/input/InputValidator';
import InputValidatorI from '../../../../../../form/input/InputValidatorI';

export default class VnAnschriftStrasseValidator implements InputValidatorI {

    static MAX_LENGTH = 30;

    private value?: string;

    constructor(newValue?: string) {
        this.value = newValue;
    }


    // *****************
    // Validator
    // ********************
    validate() {
        // *** is blank
        if (InputValidator.isBlank(this.value)) {
            return InputValidationStateBo.createInValid("Geben Sie bitte eine Straße an.")
        }

        // *** Wert is gueltig!
        return InputValidationStateBo.createValid();
    }

}